/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'
import { Button, Table, Glyphicon } from 'react-bootstrap'
import { connect } from 'react-redux'

import CarrierRow from './CarrierRow'
import AddCarrierBox from './AddCarrierBox'

type Props = {
  carriers: [
    {
      _id: String,
      email: String,
      tags: [String],
      lastActive: String,
    }
  ],
  vendors: [
    {
      _id: String,
      email: String,
      name: String,
    }
  ],
  addCarrier: Function,
  submitCarrier: Function,
  removeCarrier: Function,
}

const defaultSortDirection = -1

const Carriers = ({ carriers, vendors, addCarrier }: Props) => {
  const [showAddCarrierBox, setShowAddCarrierBox] = useState(false)
  const [sortProperty, setSortProperty] = useState('')
  const [sortDirection, setSortDirection] = useState(defaultSortDirection)

  const onChangeSort = (newSortProperty) => {
    if (sortProperty === newSortProperty) {
      setSortDirection(sortDirection * -1)
    } else {
      setSortProperty(newSortProperty)
      setSortDirection(defaultSortDirection)
    }
  }

  const sortedCarriers = carriers
    ? [...carriers].sort((a, b) => {
        if (sortProperty === 'lastActive') {
          if (!a.lastActive) return 1
          if (!b.lastActive) return -1

          if (new Date(a.lastActive).getTime() < new Date(b.lastActive).getTime()) return sortDirection
          if (new Date(a.lastActive).getTime() > new Date(b.lastActive).getTime()) return sortDirection * -1
        }

        if (sortProperty === 'organization') {
          if (!a.organization) return 1
          if (!b.organization) return -1
        }

        const aProp = (a[sortProperty] || '').toLowerCase()
        const bProp = (b[sortProperty] || '').toLowerCase()
        if (aProp < bProp) {
          return sortDirection
        }
        if (aProp > bProp) {
          return sortDirection * -1
        }
        return 0
      })
    : []

  return (
    <div>
      <Button onClick={() => setShowAddCarrierBox(!showAddCarrierBox)} style={{ marginBottom: 10 }} className="add-lock-btn" bsSize="small" block>
        <Glyphicon glyph="glyphicon glyphicon-plus" /> &nbsp; Lägg till ny DBF-transportör
      </Button>
      {showAddCarrierBox && <AddCarrierBox vendors={vendors} addCarrier={addCarrier} closeAddCarrierBox={() => setShowAddCarrierBox(false)} />}
      <Table responsive style={{ backgroundColor: 'white' }}>
        <thead>
          <tr>
            <th style={{ width: '10%' }} />
            <th style={{ width: '10%' }} onClick={() => onChangeSort('organization')}>
              <div style={{ float: 'left' }}>{sortProperty === 'organization' ? sortDirection < 0 ? <Glyphicon glyph="glyphicon glyphicon-arrow-up" /> : <Glyphicon glyph="glyphicon glyphicon-arrow-down" /> : <Glyphicon glyph="glyphicon glyphicon-sort" />}</div>
              Namn
            </th>
            <th style={{ width: '10%' }}>Email</th>
            <th style={{ width: '10%' }}>Typ</th>
            <th onClick={() => onChangeSort('lastActive')}>
              <div style={{ float: 'left' }}>{sortProperty === 'lastActive' ? sortDirection < 0 ? <Glyphicon glyph="glyphicon glyphicon-arrow-up" /> : <Glyphicon glyph="glyphicon glyphicon-arrow-down" /> : <Glyphicon glyph="glyphicon glyphicon-sort" />}</div>
              Senast aktiv
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedCarriers.map((v) => (
            <CarrierRow key={v._id} {...v} />
          ))}
        </tbody>
      </Table>
    </div>
  )
}

const mapState = (state) => ({
  carriers: state.collectionData.carriers,
  vendors: state.collectionData.vendors,
})

const mapDispatch = (dispatch) => ({})

export default connect(
  mapState,
  mapDispatch
)(Carriers)
